import SideBarLayout from 'common/layouts/SideBarLayout/SideBarLayout';
import SideBarAudio from 'modules/glifos-rich-media/components/SideBarAudio/SideBarAudio';
import SideBarVideo from 'modules/glifos-rich-media/components/SideBarVideo/SideBarVideo';
import Alert from 'modules/website/components/Alert/Alert';
import ContentCard from 'modules/website/components/ContentCard/ContentCard';
import OrderBy from 'modules/website/components/Research/OrderBy/OrderBy';
import { useCategories, useCategoryId, useCategoryTreePage } from 'modules/website/hooks/useCategoryTreePage';
import React, { useEffect, useState } from 'react'
import { Col, Placeholder, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import styles from './CategoryView.module.scss';
import ApiURLs from 'services/BackendApi/BackendApiURLs';
import SideBarDocument from 'modules/glifos-rich-media/components/SideBarDocument/SideBarDocument';
import BasicLayout from 'common/layouts/BasicLayout/BasicLayout';
import SearchSquareForm from 'modules/glifos-rich-media/components/SearchSquareForm/SearchSquareForm';
import BrowseSquare from 'modules/website/components/BrowseSquare/BrowseSquare';
import OptionCard from 'modules/website/components/Category/OptionCard/OptionCard';
import Pagination from 'modules/website/components/Pagination/Pagination';
import LoadingBody from 'modules/website/components/loadingBody/loadingBody';
import Header from 'modules/website/components/Article/Header/Header';
import GeneralLeftBar from 'modules/website/components/GeneralLeftBar/GeneralLeftBar';
import CitationCard from 'modules/website/components/CitationCard/CitationCard';

export default function CategoriesView( props ) {
  const { useWhiteLogo } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const alias = location.pathname.replace('/', '');
  //console.log(alias)
  //const { category } = useParams();
  //const tid = 8212;
  const [breadC, setBreadC] = useState(null);
  const [sideBar, setSideBar] = useState(null);
  const [order, setOrder] = useState('sorttitle')
  const [page, setPage] = useState(1);

  /* const { isLoading: isLoadingId, isError: isErrorId, payload: payloadId, error: errorId } = useCategoryId({
    //category: 'category-' + tid,
    alias: alias,
  }); */
  const { isLoading, isError, payload, error } = useCategories({
    sortby: order,
    addcategory: 'true',
    page: page,
  });

  const url = new URL(window.location.href);
  const pageUrl = url.searchParams.get('page');

  useEffect(() => {
    setPage(pageUrl);
  }, [pageUrl]);

  useEffect(() => {
    if (isError) {
      navigate('/404')
    }
  }, [isError])

  if (isLoading) return (
    <SideBarLayout
      useWhiteLogo={useWhiteLogo}
      leftBar={<GeneralLeftBar />}>
      <div>
        <div className="d-flex justify-content-between p-0">
          <Placeholder xs={4} className="plHol" />
          <Placeholder xs={4} className="plHol" />
        </div>
        <Row className="bod">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val) => {
            return (
              <Placeholder as="p" animation="wave">
                <Placeholder xs={7} size="sm" /> <Placeholder xs={4} size="sm" />
                <Placeholder xs={4} size="sm" /> <Placeholder xs={7} size="sm" />
                <Placeholder xs={8} size="sm" /> <Placeholder xs={3} size="sm" />
                <Placeholder xs={3} size="sm" /> <Placeholder xs={3} size="sm" /> <Placeholder xs={3} size="sm" /> <Placeholder xs={1} size="sm" />
              </Placeholder>
            );
          })}
        </Row>
      </div>
    </SideBarLayout>
  )

  //console.log(isErrorId)
  //console.log(isError)

  if (!isLoading && !isError && payload) {
    return (
      <SideBarLayout
        title={"Categories"}
        description={payload.description}
        leftBar={<GeneralLeftBar />}
        useWhiteLogo={useWhiteLogo}
      >
        {isLoading && <LoadingBody />}
        {!isLoading && isError && <Alert variant='danger'>{error}</Alert>}
        {!isLoading && !isError && payload && (
          <div>
            {/* <div className={`${styles.categories}`}>
              {
                payload?.parent_category && payload?.parent_category.length > 0 && (
                  <>
                    <Link to='/'>Categories: </Link>
                    <div className={`${styles.category}`}>
                      <Link to={payload?.parent_category[0].tid}>{payload?.parent_category[0].name}</Link>
                    </div>
                  </>
                )
              }
            </div> */}
            {/* <Header title={payload.title} /> */}
            <div className={`${styles.title}`}>Categories</div>
            <div className={`${styles.description}`}>
              <div dangerouslySetInnerHTML={{ __html: payload?.description }} />
            </div>
            <div className='d-flex justify-content-between p-0 mb-5'>
              {/* <OrderBy
                order={order}
                setOrder={setOrder}
              /> */}
              {payload?.result_header?.total_results !== "NaN" &&
                payload?.result_header?.total_results > 0 && (
                  <div className="d-flex flex-column justify-content-center ms-2 ">
                    {payload?.result_header?.total_results !== "NaN"
                      ? payload?.result_header?.total_results
                      : "0"}{" "}
                    results
                  </div>
                )}
              <Pagination result_header={payload?.result_header} justify='end' />
            </div>
            <Row className={`${styles.rowCards}`}>

              {/* {payload?.solr_content?.records?.record?.map((option, index) => (
                  <Col lg={4} md={12} key={index}>
                    <ContentCard title={option.title} link={option.id} description={option.blurb} image={option.image} />
                  </Col>
                ))} */}
              {payload?.records?.record ?
                (Array.isArray(
                  payload?.records?.record
                ) ? (
                  payload?.records?.record.length > 0 ? (
                    payload?.records?.record?.map(
                      (item, index) => {
                        return (

                            <Col
                              key={index}
                              md={12}
                              lg={12}
                              xl={12}
                            >
                              {
                                item.contenttype === 'glifos_digital_archive' ? <CitationCard data={item} /> : (
                                  <ContentCard
                                    key={index}
                                    title={item.title}
                                    image={
                                      ApiURLs.baseURL +
                                      item.thumbnail
                                    }
                                    description={item.blurb}
                                    nav={item.id}
                                    searchable={item.searchable}
                                  />
                                )
                              }
                            </Col>
                          )
                      }
                    )
                  ) : (
                    <div className={`${styles.noFound}`}>
                      No results were found
                    </div>
                  )

                ) : (
                  <Col md={12} lg={4} className='mb-4'>
                    <ContentCard
                      title={
                        payload?.records
                          ?.record.title
                      }
                      image={
                        ApiURLs.baseURL +
                        payload?.records
                          ?.record.thumbnail
                      }
                      description={
                        payload?.records
                          ?.record.blurb
                      }
                      nav={
                        payload?.records
                          ?.record.id
                      }
                    />
                  </Col>
                ))
                :
                <div className={`${styles.noFound}`}>
                  No results were found
                </div>
              }
            </Row>
            <div className='mt-5 mb-5'>
              <Pagination result_header={payload?.result_header} justify='start' />
            </div>
          </div>

        )}
      </SideBarLayout>
    )
  }
}
